module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "427px"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('h1', [_vm._v("Dela dina sparade bokningar")]), _vm._v(" "), _c('p', [_vm._v("Klicka på "), _c('b', [_vm._v("kopiera länken")]), _vm._v(" nedan och klistra in länken och dela den. Du kan också spara den som en av dina favoriter i webbläsaren.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    ref: "copyText",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.link
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "medium",
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("Kopiera länken")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5d85cd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/AccomodationCompareShare.vue
// module id = 1035
// module chunks = 0